var map = {
	"./462678.png": "WfdS",
	"./chat_bot.svg": "uG7c",
	"./chatbot_tebot.png": "tv0t",
	"./close.svg": "8yPs",
	"./handShake.svg": "pxLK",
	"./hybrid-slider.png": "oVpv",
	"./icon-02.png": "nmTx",
	"./icon-03.png": "MpUD",
	"./menu.svg": "xWT1",
	"./mobile_pay.svg": "yfuf",
	"./moon.svg": "v6Sn",
	"./progressive_app.svg": "e0zN",
	"./subscribeCard.svg": "7oIj",
	"./sun.svg": "TUD+",
	"./virtual_reality.svg": "lQgE",
	"./vr-man.png": "xBAD"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "s8AE";